import React, { useEffect, useState } from "react";
import { Crosshair, RefreshCw } from "lucide-react";
import { positioningGex } from "../lib/api";

const Lvl = ({ label, v, cls, id }) => (
  <div><p className="text-[10px] text-cyan-200/50">{label}</p><p className={`font-bold ${cls}`} data-testid={id}>{v ?? "—"}</p></div>
);

export const GexCard = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = (refresh) => { setBusy(true); positioningGex(refresh).then(setD).catch(() => setD({})).finally(() => setBusy(false)); };
  useEffect(() => { load(false); }, []);
  return (
    <div className="bg-[#060b18] border border-[#00F0FF22] rounded-2xl p-4 space-y-3" data-testid="gex-card">
      <div className="flex items-center justify-between">
        <p className="text-[#00F0FF] font-bold flex items-center gap-2"><Crosshair className="w-4 h-4" /> Prakash · dealer gamma levels {d?.date && <span className="text-xs text-cyan-200/50 font-normal" data-testid="gex-date">{d.date}</span>}</p>
        <button onClick={() => load(true)} disabled={busy} className="text-xs text-cyan-200/70 hover:text-[#00F0FF] transition-colors flex items-center gap-1" data-testid="gex-refresh-btn">
          <RefreshCw className={`w-3 h-3 ${busy ? "animate-spin" : ""}`} /> Republish
        </button>
      </div>
      {!d ? <p className="text-xs text-cyan-200/40">Loading…</p> : !d.levels?.length ? <p className="text-xs text-cyan-200/40" data-testid="gex-empty">No level set yet — publishes 8:00 AM CT weekdays.</p> : (
        <div className="grid sm:grid-cols-3 gap-2">
          {d.levels.map((g) => (
            <div key={g.symbol} className="rounded-lg border border-[#00F0FF14] p-2.5 text-xs space-y-2" data-testid={`gex-${g.symbol}`}>
              <div className="flex justify-between"><span className="font-bold text-cyan-50">{g.symbol}</span><span className="text-cyan-200/60">spot {g.spot}</span></div>
              <div className="grid grid-cols-3 gap-1">
                <Lvl label="Put wall" v={g.put_wall} cls="text-emerald-400" id={`gex-${g.symbol}-put`} />
                <Lvl label="Flip" v={g.zero_gamma_flip} cls="text-amber-300" id={`gex-${g.symbol}-flip`} />
                <Lvl label="Call wall" v={g.call_wall} cls="text-rose-400" id={`gex-${g.symbol}-call`} />
              </div>
              <p className={g.net_gex_bn > 0 ? "text-emerald-300/80" : "text-rose-300/80"} data-testid={`gex-${g.symbol}-regime`}>{g.regime}</p>
            </div>))}
        </div>
      )}
      <p className="text-[10px] text-cyan-200/40">Regime first, money flow second, risk third — positioning refines levels, never overrides.</p>
    </div>
  );
};
